import styled, { css } from "styled-components";
import tw from "twin.macro";

import { BoxSizingStyle } from "../BoxSizingStyle";
import { Button } from "../Button/Button";
import { ConfirmDialog } from "../ConfirmDialog";
import { FontStyle } from "../FontStyle";

export const StyledSelectDate = styled.div`
  ${FontStyle}
  ${BoxSizingStyle}
`;

StyledSelectDate.displayName = "StyledSelectDate";

export const StyledSelectDateButton = styled.button`
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  width: auto;
  height: auto;
  color: var(--color-theme-700);

  span,
  svg {
    cursor: pointer;
  }
  span {
    color: var(--color-secondary);
  }
  svg:hover {
    fill: var(--color-secondary);
  }
`;

StyledSelectDateButton.displayName = "StyledSelectDateButton";

export const StyledConfirmDialog = styled(ConfirmDialog)`
  .modal-header {
    padding: 16px 30px;
    h1 {
      margin: 0;
      font-size: 16px;
    }
  }
  .modal-body {
    padding: 10px 30px;
  }
  .modal-divider {
    border-top: 1px solid var(--border-primary);
    height: 1px;
  }
  .modal-footer {
    padding: 16px 30px;
  }
`;

StyledConfirmDialog.displayName = "StyledConfirmDialog";

export const StyledSelectDateDatePicker = styled.div`
  ${tw`tw-pt-4 tw-pb-2`}
  color: red;
`;

StyledSelectDateDatePicker.displayName = "StyledSelectDateDatePicker";

export const StyledSelectDateFooter = styled.div<{
  $mode?: "atomic" | "instant";
}>`
  ${tw`tw-px-4 tw-py-2`}
  border-top: 1px solid var(--border-primary);

  ${(props) =>
    props.$mode === "instant" &&
    css`
      ${tw`tw-flex`}
    `}
`;

StyledSelectDateFooter.displayName = "StyledSelectDateFooter";

export const StyledSelectDateButtons = styled.div`
  ${tw`tw-flex`}
`;

StyledSelectDateButtons.displayName = "StyledSelectDateButtons";

export const StyledButtonSave = styled(Button)`
  ${tw`tw-mr-2`}
`;

StyledButtonSave.displayName = "StyledButtonSave";

export const StyledButtonClose = styled(Button)`
  ${tw`tw-ml-auto`}
`;

StyledButtonClose.displayName = "StyledButtonClose";

export const StyledButtonCloseColored = styled(Button)`
  ${tw`tw-ml-auto tw-mr-auto`}
`;

StyledButtonCloseColored.displayName = "StyledButtonCloseColored";

export const StyledIconComponent = styled.svg`
  span,
  svg {
    cursor: pointer;
  }
  span {
    color: var(--color-secondary);
  }
  svg:hover {
    fill: var(--color-secondary);
  }
`;

StyledIconComponent.displayName = "StyledIconComponent";
